import { render, staticRenderFns } from "./pickupTour.vue?vue&type=template&id=721dd87e&scoped=true"
import script from "./pickupTour.vue?vue&type=script&lang=js"
export * from "./pickupTour.vue?vue&type=script&lang=js"
import style0 from "./pickupTour.vue?vue&type=style&index=0&id=721dd87e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721dd87e",
  null
  
)

export default component.exports